<template>
    <div class="cart-payment">
        <span class="cart-payment-span">Subtotal</span>
    	<span class="cart-payment-value">{{ p_subtotal }}</span>

        <!--<span class="cart-payment-span">Cargo por servicio Candy</span>
    	<span class="cart-payment-value">{{ p_c_service }}</span>-->

        <span class="cart-payment-span-total">TOTAL</span>
        <span class="cart-payment-value-total">{{ p_total }}</span>
    </div>
</template>

<script>
export default {
    name: 'name',
    props:{
        p_subtotal: { type: String, default: () => '$0'},
        p_c_service: { type: String, default: () => '$0'},
        p_total: { type: String, default: () => '$0'}
    },
    methods: {}
}
</script>


// WEBPACK FOOTER //
// src/components/Total.vue